export default "__VITE_ASSET__NANttk$a__"